import { toast } from "react-toastify";
import { USERS_API } from "../views/MainLayout/components/shared/services/users";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialUsers = []

export const usersReducer = (state = initialUsers, action) => {
    switch(action.type){
        case "users/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchUsers = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await USERS_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'users/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}